import i18n from '@/utils/i18n';
import { useConfidentialVisibilityStore } from '@/experiences/sales-portal/domain/ordering/blocs/stores/order-entry-confidential-visibility-store';

export interface UseConfidentialFieldToggleReturn {
  accessibilityLabel: string;
  isVisible: boolean;
  onToggle: () => void;
}

/**
 * Reads and flips the persisted confidential-field visibility for an eye toggle.
 *
 * @returns Whether confidential fields show, the action that flips them, and the matching accessibility label.
 */
export const useConfidentialFieldToggle =
  (): UseConfidentialFieldToggleReturn => {
    const isVisible = useConfidentialVisibilityStore(
      (state) => state.showConfidentialFields,
    );
    const onToggle = useConfidentialVisibilityStore(
      (state) => state.toggleConfidentialFieldDisplay,
    );

    return {
      accessibilityLabel: isVisible
        ? i18n.t('sales_portal.order_entry.confidential_toggle.hide_label')
        : i18n.t('sales_portal.order_entry.confidential_toggle.show_label'),
      isVisible,
      onToggle,
    };
  };
